var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLifeStyleLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 276,
    viewBox: "0 0 306 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.3003 89.8V0.5H239.5V89.8H198.3V41.5H108.4V89.8H67.3003Z",
    fill: "#C11446"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3003 186.1V275.4H239.5V186.1H198.3V234.4H108.4V186.1H67.3003Z",
    fill: "#C11446"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M173.7 85.0999H132.7V190.8H173.7V85.0999Z",
    fill: "#EDAB18"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M305.4 0.399902H264.4V275.5H305.4V0.399902Z",
    fill: "#C11446"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6001 0.399902H0.600098V275.5H41.6001V0.399902Z",
    fill: "#C11446"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeStyleLight);
export default __webpack_public_path__ + "static/media/life-style-light.0044c540b9453172df30074d035ad534.svg";
export { ForwardRef as ReactComponent };